__webpack_require__.p = "/app/themes/de-rijke-noordzee/";